import { render, staticRenderFns } from "./WriteActe.vue?vue&type=template&id=381578b8&"
import script from "./WriteActe.vue?vue&type=script&lang=js&"
export * from "./WriteActe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports